import React from 'react';
import BaseFileIcon from '../BaseFileIcon';

const XlsIcon = ({ color = '#13a085', text = 'XLS' }) => (
  <BaseFileIcon color={color} text={text} />
);

export default XlsIcon;
